import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { PXTextModalWrapper } from 'Views/Page/Content/Modal/Layouts/PXTextModalWrapper';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';

const Layout = () => {
  return (
    <PXTextModalWrapper>
      <MetaControlField attr={'description'} />
      <MetaLayoutRemainingFields />
    </PXTextModalWrapper>
  );
};

export default Layout;
